import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"

const IconSlack = ({
  title = "Slack",
  viewBoxWidth = 40,
  viewBoxHeight = 40,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g id="Slack" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <rect id="Rectangle-Slack" x="0" y="0" width="40" height="40" />
      <path
        d="M8.98355217,25.0128609 C8.98355217,27.2099217 7.18871304,29.0047609 4.99181739,29.0047609 C2.79500435,29.0047609 1.00024783,27.2098391 1.00024783,25.0128609 C1.00024783,22.8161304 2.79508696,21.0213739 4.99181739,21.0213739 L8.98355217,21.0213739 L8.98355217,25.0128609 Z"
        id="Path-1"
        fill="#E01E5A"
        fillRule="nonzero"
      />
      <path
        d="M10.9953217,25.0128609 C10.9953217,22.8161304 12.7902435,21.0213739 14.9870565,21.0213739 C17.1838696,21.0213739 18.9787087,22.816213 18.9787087,25.0128609 L18.9787087,35.0083478 C18.9787087,37.2050783 17.183787,38.9999174 14.9870565,38.9999174 C12.7901609,38.9999174 10.9953217,37.2049957 10.9953217,35.0083478 L10.9953217,25.0128609 Z"
        id="Path-2"
        fill="#E01E5A"
        fillRule="nonzero"
      />
      <path
        d="M14.9870565,8.98355217 C12.7901609,8.98355217 10.9953217,7.18863043 10.9953217,4.99181739 C10.9953217,2.79500435 12.7902435,1.00016522 14.9870565,1.00016522 C17.1838696,1.00016522 18.9787087,2.79508696 18.9787087,4.99181739 L18.9787087,8.98355217 L14.9870565,8.98355217 L14.9870565,8.98355217 Z"
        id="Path-3"
        fill="#36C5F0"
        fillRule="nonzero"
      />
      <path
        d="M14.9870565,10.9954043 C17.1838696,10.9954043 18.9787087,12.7902435 18.9787087,14.9871391 C18.9787087,17.1839522 17.183787,18.9786261 14.9870565,18.9786261 L4.99173478,18.9786261 C2.79492174,18.9786261 1.00016522,17.1838696 1.00016522,14.9871391 C1.00016522,12.7901609 2.79500435,10.9954043 4.99173478,10.9954043 L14.9870565,10.9954043 L14.9870565,10.9954043 Z"
        id="Path-4"
        fill="#36C5F0"
        fillRule="nonzero"
      />
      <path
        d="M31.016613,14.9871391 C31.016613,12.7901609 32.811287,10.9954043 35.0082652,10.9954043 C37.2050783,10.9954043 38.9997522,12.7902435 38.9997522,14.9871391 C38.9997522,17.1839522 37.2049957,18.9786261 35.0082652,18.9786261 L31.016613,18.9786261 L31.016613,14.9871391 L31.016613,14.9871391 Z"
        id="Path-5"
        fill="#2EB67D"
        fillRule="nonzero"
      />
      <path
        d="M29.0046783,14.9871391 C29.0046783,17.1839522 27.2097565,18.9786261 25.0129435,18.9786261 C22.8161304,18.9786261 21.0212913,17.1838696 21.0212913,14.9871391 L21.0212913,4.99173478 C21.0212913,2.79492174 22.816213,1.00008261 25.0129435,1.00008261 C27.2098391,1.00008261 29.0046783,2.79500435 29.0046783,4.99173478 L29.0046783,14.9871391 L29.0046783,14.9871391 Z"
        id="Path-6"
        fill="#2EB67D"
        fillRule="nonzero"
      />
      <path
        d="M25.0129435,31.0165304 C27.2098391,31.0165304 29.0046783,32.8113696 29.0046783,35.0082652 C29.0046783,37.2049957 27.2097565,38.9998348 25.0129435,38.9998348 C22.8161304,38.9998348 21.0212913,37.204913 21.0212913,35.0082652 L21.0212913,31.0165304 L25.0129435,31.0165304 L25.0129435,31.0165304 Z"
        id="Path-7"
        fill="#ECB22E"
        fillRule="nonzero"
      />
      <path
        d="M25.0129435,29.0047609 C22.8161304,29.0047609 21.0212913,27.2098391 21.0212913,25.0128609 C21.0212913,22.8161304 22.816213,21.0213739 25.0129435,21.0213739 L35.0083478,21.0213739 C37.2051609,21.0213739 38.9998348,22.816213 38.9998348,25.0128609 C38.9998348,27.2099217 37.2050783,29.0047609 35.0083478,29.0047609 L25.0129435,29.0047609 Z"
        id="Path-8"
        fill="#ECB22E"
        fillRule="nonzero"
      />
    </g>
  </Svg.Icon>
)

export default IconSlack
